import isNil from 'ramda/src/isNil';
import { useState } from 'react';

/**
 * Hook to add syntactic sugar to a state to control a modal/overlay shown state
 * It returns an array containing 3 things:
 * 1. shown (boolean)
 * 2. show function
 * 3. hide function
 *
 * e.g.: const [modalShown, showModal, hideModal] = useModalControls();
 * if (modalShown) {
 *   hideModal();
 * } else {
 *   showModal();
 * }
 * @param initialState Optional parameter to set the initial display state of the modal
 */
export const useModalControls = (initialState?: boolean): [boolean, () => void, () => void] => {
  const [shown, setShown] = useState<boolean>(isNil(initialState) ? false : initialState);
  return [
    shown,
    (): void => {
      setShown(true);
    },
    (): void => {
      setShown(false);
    },
  ];
};



// WEBPACK FOOTER //
// /codebuild/output/src891534606/src/modules/common/src/hook/use-modal-controls.ts